/* FragSplit mega menu (desktop >= 1200px) — voir snippets/fs-mega-panel.liquid */
(function () {
  var desktop = window.matchMedia('(min-width: 1200px)');
  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 180;
  var openHost = null;
  var openTimer = null;
  var closeTimer = null;

  function toggleOf(host) {
    return host.querySelector(':scope > a.site-nav__parent-toggle');
  }

  function open(host) {
    clearTimeout(closeTimer);
    if (openHost === host) return;
    if (openHost) close(openHost, true);
    host.classList.add('is-open');
    var t = toggleOf(host);
    if (t) t.setAttribute('aria-expanded', 'true');
    openHost = host;
  }

  function close(host, immediate) {
    if (!host) return;
    host.classList.remove('is-open');
    var t = toggleOf(host);
    if (t) t.setAttribute('aria-expanded', 'false');
    if (openHost === host) openHost = null;
  }

  function bindHost(host) {
    if (host.dataset.fsMegaBound) return;
    host.dataset.fsMegaBound = '1';

    host.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      // Bascule immediate si un autre panneau est deja ouvert
      if (openHost && openHost !== host) open(host);
      else openTimer = setTimeout(function () { open(host); }, OPEN_DELAY);
    });
    host.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { close(host); }, CLOSE_DELAY);
    });

    var t = toggleOf(host);
    if (t) {
      t.setAttribute('aria-haspopup', 'true');
      t.addEventListener('click', function (e) {
        if (!desktop.matches) return;
        e.preventDefault();
        var parentHref = t.getAttribute('data-parent-href');
        if (parentHref && parentHref !== '#') { window.location.href = parentHref; return; }
        if (host.classList.contains('is-open')) close(host);
        else open(host);
      });
      t.addEventListener('keydown', function (e) {
        if (!desktop.matches) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(host);
          var first = host.querySelector('.fs-mega a, .fs-mega button, .fs-mega input');
          if (first) first.focus();
        }
      });
    }

    /* fs-click-inside : un clic dans une zone vide du menu ne le ferme plus */
    host.addEventListener('focusout', function (e) {
      if (!desktop.matches) return;
      if (e.relatedTarget && !host.contains(e.relatedTarget)) close(host);
    });

    var brands = host.querySelector('[data-fs-brands]');
    if (brands) {
      lettersIndex(brands);
      bindBrands(brands);
    }

    var notes = host.querySelector('[data-fs-notes]');
    if (notes) {
      var load = function () { loadNotes(notes); };
      host.addEventListener('mouseenter', load, { once: true });
      host.addEventListener('focusin', load, { once: true });
    }
  }

  // Marques : les groupes du menu Shopify (A-B, C-G...) sont regroupes par lettre,
  // avec le meme index A-Z que les notes. Les liens restent ceux du menu.
  function lettersIndex(root) {
    var tabs = root.querySelector('.fs-mega__tabs');
    var main = root.querySelector('.fs-mega__brands-main');
    var results = root.querySelector('[data-fs-brands-results]');
    var oldGroups = root.querySelectorAll('[data-fs-brands-group]');
    if (!tabs || !main || !results || !oldGroups.length) return;

    var fold = function (v) { return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase(); };
    var byLetter = {};
    oldGroups.forEach(function (g) {
      g.querySelectorAll('a').forEach(function (a) {
        var c = fold(a.textContent.trim()).charAt(0);
        var l = /[A-Z]/.test(c) ? c : '#';
        (byLetter[l] = byLetter[l] || []).push(a);
      });
    });
    var letters = Object.keys(byLetter).sort(function (a, b) { return a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b); });
    if (!letters.length) return;

    var logos = {};
    try { logos = JSON.parse((root.parentNode.querySelector('[data-fs-brand-logos]') || {}).textContent || '{}'); } catch (e) {}
    Object.keys(byLetter).forEach(function (l) {
      byLetter[l].forEach(function (a) {
        if (a.querySelector('.fs-mega__blogo')) return;
        var name = a.textContent.trim();
        a.setAttribute('data-fs-name', name);
        var src = logos[name.toLowerCase()];
        var box = document.createElement('span');
        box.className = 'fs-mega__blogo' + (src ? '' : ' is-empty');
        if (src) {
          var img = document.createElement('img');
          img.src = src; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          box.appendChild(img);
        } else {
          box.textContent = name.charAt(0).toUpperCase();
        }
        var label = document.createElement('span');
        label.textContent = name;
        a.textContent = '';
        a.appendChild(box);
        a.appendChild(label);
      });
    });

    var pid = (root.closest('[data-fs-mega]') || {}).id || 'FsMegaBrands';
    tabs.innerHTML = '';
    tabs.classList.add('fs-mega__tabs--letters');
    oldGroups.forEach(function (g) { g.remove(); });
    letters.forEach(function (l, idx) {
      var id = String(idx + 1);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fs-mega__tab' + (idx === 0 ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.id = pid + '-ltab-' + id;
      btn.setAttribute('aria-controls', pid + '-lgroup-' + id);
      btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      btn.setAttribute('data-fs-brands-tab', id);
      btn.textContent = l;
      tabs.appendChild(btn);

      var ul = document.createElement('ul');
      ul.className = 'fs-mega__brand-list';
      ul.id = pid + '-lgroup-' + id;
      ul.setAttribute('role', 'tabpanel');
      ul.setAttribute('aria-labelledby', btn.id);
      ul.setAttribute('data-fs-brands-group', id);
      if (idx) ul.hidden = true;
      byLetter[l].sort(function (a, b) { return (a.getAttribute('data-fs-name') || a.textContent).localeCompare(b.getAttribute('data-fs-name') || b.textContent, 'fr', { sensitivity: 'base' }); })
        .forEach(function (a) { var li = document.createElement('li'); li.appendChild(a); ul.appendChild(li); });
      main.insertBefore(ul, results);
    });
  }

  // Notes olfactives : meme source que la page Notes (collection parfums, vue notes-directory-data),
  // dedoublonnees, triees, un onglet par lettre, puis meme logique que Marques.
  function loadNotes(root) {
    if (root.dataset.fsNotesState) return;
    root.dataset.fsNotesState = 'loading';
    var CACHE = 'fsMegaNotes:v1';
    var fold = function (v) { return String(v || '').replace(/[Œœ]/g, 'OE').replace(/[Ææ]/g, 'AE').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase(); };
    var key = function (v) { return fold(v).replace(/[^A-Z0-9]+/g, ' ').trim(); };
    var letterOf = function (v) { var c = fold(v).charAt(0); return /[A-Z]/.test(c) ? c : '#'; };

    function fetchAll() {
      try {
        var cached = sessionStorage.getItem(CACHE);
        if (cached) return Promise.resolve(JSON.parse(cached));
      } catch (e) {}
      var src = root.getAttribute('data-src');
      var get = function (url) {
        return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
      };
      return get(src).then(function (first) {
        var jobs = [];
        for (var n = 2; n <= first.pages; n++) jobs.push(get(src.replace(/page=\d+/, 'page=' + n)));
        return Promise.all(jobs).then(function (rest) { return [first].concat(rest); });
      }).then(function (pages) {
        var map = new Map();
        pages.forEach(function (pg) {
          (pg.notes || []).forEach(function (n) { var k = key(n.name); if (k && !map.has(k)) map.set(k, n); });
        });
        var list = Array.from(map.values()).sort(function (a, b) {
          return a.name.localeCompare(b.name, 'fr', { sensitivity: 'base', numeric: true });
        });
        try { sessionStorage.setItem(CACHE, JSON.stringify(list)); } catch (e) {}
        return list;
      });
    }

    function noteLink(n) {
      var a = document.createElement('a');
      a.href = n.url;
      a.className = 'fs-mega__link fs-mega__note';
      var img = document.createElement('img');
      img.alt = '';
      img.width = 22;
      img.height = 22;
      img.loading = 'lazy';
      img.decoding = 'async';
      var tries = [n.png, n.fallback], i = 0;
      img.onerror = function () {
        if (i < tries.length) { img.src = tries[i++]; return; }
        var ph = document.createElement('span');
        ph.className = 'fs-mega__note-ph';
        ph.textContent = (n.name || '?').trim().charAt(0).toUpperCase();
        img.replaceWith(ph);
      };
      img.src = n.webp;
      var span = document.createElement('span');
      span.textContent = n.name;
      a.appendChild(img);
      a.appendChild(span);
      return a;
    }

    fetchAll().then(function (list) {
      var byLetter = {};
      list.forEach(function (n) { var l = letterOf(n.name); (byLetter[l] = byLetter[l] || []).push(n); });
      var letters = Object.keys(byLetter).sort(function (a, b) { return a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b); });
      // Un onglet par lettre (index A-Z compact)
      var groups = letters.map(function (l) { return { from: l, to: l, items: byLetter[l] }; });

      var tabs = root.querySelector('[data-fs-notes-tabs]');
      tabs.classList.add('fs-mega__tabs--letters');
      var main = root.querySelector('[data-fs-notes-main]');
      var results = root.querySelector('[data-fs-brands-results]');
      var pid = (root.closest('[data-fs-mega]') || {}).id || 'FsMegaNotes';
      groups.forEach(function (g, idx) {
        var id = String(idx + 1);
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fs-mega__tab' + (idx === 0 ? ' is-active' : '');
        btn.setAttribute('role', 'tab');
        btn.id = pid + '-ntab-' + id;
        btn.setAttribute('aria-controls', pid + '-ngroup-' + id);
        btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
        btn.setAttribute('data-fs-brands-tab', id);
        btn.textContent = g.from === g.to ? g.from : g.from + '-' + g.to;
        tabs.appendChild(btn);

        var ul = document.createElement('ul');
        ul.className = 'fs-mega__brand-list';
        ul.id = pid + '-ngroup-' + id;
        ul.setAttribute('role', 'tabpanel');
        ul.setAttribute('aria-labelledby', btn.id);
        ul.setAttribute('data-fs-brands-group', id);
        if (idx) ul.hidden = true;
        g.items.forEach(function (n) { var li = document.createElement('li'); li.appendChild(noteLink(n)); ul.appendChild(li); });
        main.insertBefore(ul, results);
      });
      var loading = root.querySelector('[data-fs-notes-loading]');
      if (loading) loading.remove();
      root.dataset.fsNotesState = 'ready';
      bindBrands(root);
    }).catch(function () {
      root.dataset.fsNotesState = '';
      var loading = root.querySelector('[data-fs-notes-loading]');
      if (loading) loading.hidden = true;
    });
  }

  function bindBrands(root) {
    var tabs = root.querySelectorAll('[data-fs-brands-tab]');
    var groups = root.querySelectorAll('[data-fs-brands-group]');
    var input = root.querySelector('[data-fs-brands-search]');
    var results = root.querySelector('[data-fs-brands-results]');
    var empty = root.querySelector('[data-fs-brands-empty]');
    var active = '1';

    function show(id) {
      active = id;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-fs-brands-tab') === id;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      groups.forEach(function (g) {
        g.hidden = g.getAttribute('data-fs-brands-group') !== id;
      });
    }

    tabs.forEach(function (tab) {
      var id = tab.getAttribute('data-fs-brands-tab');
      function activate() {
        if (input && input.value) { input.value = ''; search(''); }
        show(id);
      }
      /* fs-letter-lock : un clic verrouille la lettre jusqu'a la sortie du menu */
      tab.addEventListener('click', function () {
        root.__fsLock = true;
        activate();
        var host = root.closest('[data-fs-mega-host]');
        if (host && !host.__fsLockBound) {
          host.__fsLockBound = true;
          host.addEventListener('mouseleave', function () { root.__fsLock = false; });
        }
      });
      tab.addEventListener('focus', activate);
      /* fs-hover-intent : survol actif seulement si le pointeur s'arrete sur la lettre */
      (function () {
        var timer = null, startX = 0, moved = false;
        function cancel() { clearTimeout(timer); timer = null; }
        tab.addEventListener('mouseenter', function (e) {
          if (tab.classList.contains('is-active')) return;
          startX = e.clientX; moved = false; cancel();
          timer = setTimeout(function () { timer = null; if (!root.__fsLock) activate(); }, 70);
        });
        tab.addEventListener('mousemove', function (e) {
          if (!timer) return;
          clearTimeout(timer);
          timer = setTimeout(function () { timer = null; if (!root.__fsLock) activate(); }, 70);
        });
        tab.addEventListener('mouseleave', cancel);
      })();
    });

    function normalize(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    var all = [];
    root.querySelectorAll('[data-fs-brands-group] a').forEach(function (a) {
      all.push({ el: a, key: normalize(a.getAttribute('data-fs-name') || a.textContent) });
    });

    function search(q) {
      q = normalize(q.trim());
      if (!q) {
        root.classList.remove('is-searching');
        results.hidden = true;
        empty.hidden = true;
        results.innerHTML = '';
        show(active);
        return;
      }
      root.classList.add('is-searching');
      groups.forEach(function (g) { g.hidden = true; });
      results.innerHTML = '';
      var seen = {};
      all.forEach(function (b) {
        if (b.key.indexOf(q) === -1 || seen[b.key]) return;
        seen[b.key] = true;
        var li = document.createElement('li');
        li.appendChild(b.el.cloneNode(true));
        results.appendChild(li);
      });
      results.hidden = !results.children.length;
      empty.hidden = !!results.children.length;
    }

    if (input) {
      input.addEventListener('input', function () { search(input.value); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var first = results.querySelector('a');
          if (first) { e.preventDefault(); window.location.href = first.href; }
        }
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-fs-mega-host]').forEach(bindHost);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openHost) return;
    var host = openHost;
    close(host);
    var t = toggleOf(host);
    if (t) t.focus();
  });

  document.addEventListener('click', function (e) {
    if (openHost && !openHost.contains(e.target)) close(openHost);
  });

  desktop.addEventListener('change', function () {
    if (!desktop.matches && openHost) close(openHost);
  });

  // Header "arche" (fs-header-arch.css) : 3 rubriques calees a gauche de l'arche,
  // 3 a droite, l'accroche reste exactement sous l'arche.
  function balanceNav() {
    var ul = document.querySelector('#AccessibleNav > .site-nav');
    if (!ul) return;
    var lis = Array.prototype.filter.call(ul.children, function (el) { return el.tagName === 'LI'; });
    lis.forEach(function (li) { li.style.removeProperty('margin-left'); });
    if (!desktop.matches || lis.length !== 6) { ul.classList.add('is-balanced'); return; }
    var cs = getComputedStyle(ul);
    var gap = parseFloat(cs.getPropertyValue('--fs-nav-gap')) || 40;
    var center = getComputedStyle(ul.parentElement.parentElement, '::after');
    var arch = parseFloat(center.width) || 260;
    var half = ul.clientWidth / 2;
    var left = lis[0].offsetWidth + lis[1].offsetWidth + lis[2].offsetWidth + 2 * gap;
    var m0 = Math.max(0, half - arch / 2 - gap - left);
    var m3 = arch + 2 * gap;
    lis[0].style.setProperty('margin-left', m0 + 'px', 'important');
    lis[3].style.setProperty('margin-left', m3 + 'px', 'important');
    // Recalage sur le texte reel (les liens ont des marges internes inegales)
    var title = function (li) { return (li.querySelector('.group_title') || li).getBoundingClientRect(); };
    var box = ul.getBoundingClientRect();
    var c = box.left + box.width / 2;
    var d0 = (c - arch / 2 - gap) - title(lis[2]).right;
    lis[0].style.setProperty('margin-left', Math.max(0, m0 + d0) + 'px', 'important');
    var d3 = (c + arch / 2 + gap) - title(lis[3]).left;
    lis[3].style.setProperty('margin-left', (m3 + d3) + 'px', 'important');
    ul.classList.add('is-balanced');
  }

  function start() {
    init();
    balanceNav();
    window.addEventListener('resize', balanceNav, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(balanceNav);
    window.addEventListener('load', balanceNav);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
